module.exports = __webpack_public_path__ + "img/蒙版组116@2x.839726a6.png";